export const ROTULO_STATUS_FISCAL = {
    aguardando_emissao: 'Aguardando emissão',
    em_processamento: 'Em processamento',
    emitida: 'Emitida',
    erro_emissao: 'Erro na emissão',
    cancelada: 'Cancelada',
};
/**
 * Monta a descrição comercial contínua a partir das linhas do pedido —
 * "Descrição — R$ x,xx; Descrição — R$ y,yy." Uma frase legível, nunca
 * um despejo técnico. Valores em centavos → reais com vírgula.
 */
export function montarDescricaoModificacoes(itens) {
    if (itens.length === 0)
        return '—';
    const partes = itens.map((item) => {
        const reais = (item.valorTotalCentavos / 100).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        const qtd = item.quantidade > 1 ? ` (${item.quantidade}×)` : '';
        return `${item.descricao.trim()}${qtd} — R$ ${reais}`;
    });
    return `${partes.join('; ')}.`;
}
//# sourceMappingURL=faturamento.js.map